import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class GetCountriesUseCase {
    constructor(data) {
        this.data = data;
    }
    run() {
        return this.data.getCountries();
    }
}
GetCountriesUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetCountriesUseCase_Factory() { return new GetCountriesUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: GetCountriesUseCase, providedIn: "root" });
